"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./style.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];

  if (null != _i) {
    var _s,
        _e,
        _x,
        _r,
        _arr = [],
        _n = !0,
        _d = !1;

    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) {
        ;
      }
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var FontSizeSwitcher = function FontSizeSwitcher(_ref) {
  var defaultSize = _ref.defaultSize,
      _ref$incrementMode = _ref.incrementMode,
      incrementMode = _ref$incrementMode === void 0 ? false : _ref$incrementMode;

  var getCookie = function getCookie(n) {
    var a = "; ".concat(document.cookie).match(";\\s*".concat(n, "=([^;]+)"));
    return a ? a[1] : '';
  }; // Use cookie by default to prevent flickering.


  var cookie = getCookie('WCAG_font_size');

  var _useState = (0, _react.useState)(cookie ? parseInt(cookie) : defaultSize),
      _useState2 = _slicedToArray(_useState, 2),
      currentSize = _useState2[0],
      setCurrentSize = _useState2[1];

  var changeCurrentSize = function changeCurrentSize(size) {
    if (incrementMode === true && size >= 3) {
      document.cookie = "WCAG_font_size=".concat(0);
      setCurrentSize(parseInt(0));
    } else {
      document.cookie = "WCAG_font_size=".concat(size);
      setCurrentSize(parseInt(size));
    }
  };

  (0, _react.useEffect)(function () {
    var html = document.getElementsByTagName('html')[0];
    html.classList.remove('font-size--small', 'font-size--regular', 'font-size--large');
    html.classList.add(['font-size--small', 'font-size--regular', 'font-size--large'][currentSize]);
  }, [currentSize]);
  var classesSmall = (0, _classnames.default)('FontSizeSwitcher__button FontSizeSwitcher__button--small', {
    'active': currentSize === 0
  });
  var classesRegular = (0, _classnames.default)('FontSizeSwitcher__button FontSizeSwitcher__button--regular', {
    'active': currentSize === 1
  });
  var classesLarge = (0, _classnames.default)('FontSizeSwitcher__button FontSizeSwitcher__button--large', {
    'active': currentSize === 2
  });

  if (incrementMode === true) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "FontSizeSwitcher FontSizeSwitcher--increment-mode",
      onClick: function onClick() {
        changeCurrentSize(currentSize + 1);
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: classesSmall
    }, "Small"), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: classesRegular
    }, "Regular"), /*#__PURE__*/_react.default.createElement("button", {
      type: "button",
      className: classesLarge
    }, "Large"));
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "FontSizeSwitcher"
  }, /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: classesSmall,
    onClick: function onClick() {
      return changeCurrentSize(0);
    }
  }, "Small"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: classesRegular,
    onClick: function onClick() {
      return changeCurrentSize(1);
    }
  }, "Regular"), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: classesLarge,
    onClick: function onClick() {
      return changeCurrentSize(2);
    }
  }, "Large"));
};

FontSizeSwitcher.defaultProps = {
  defaultSize: 1
};
var _default = FontSizeSwitcher;
exports.default = _default;